document.addEventListener("DOMContentLoaded", () => {
    /* 회원가입 버튼 클릭처리 */
    clickBtnRegister();

    /* customers (공통) - 페이지 링크 클릭 */
    clickLinkUser();
});

// 버튼 클릭 이벤트 리스너 함수
function clickBtnRegister() {
    let btn_register = document.querySelectorAll('.container_register .btn__register');
    if (btn_register && btn_register.length > 0) {
        btn_register.forEach(btn => {
            btn.addEventListener('click',function(e) {
                let el = e.currentTarget;

                let register_type   = el.dataset.register_type;
                let check_result    = el.dataset.check_result;

                let tmp_url = "";

                switch (register_type) {
                    case "naver":
                        let oauth_naver		= "https://nid.naver.com/oauth2.0/";
                        let client_naver	= "VY9Euld75KN5q1u0upZD";
                        let redirect_naver	= encodeURI("https://kr.sidiz.com/pages/naver-login");

                        let mt				= Date.now().toString();
                        let rand			= Math.random().toString();
                        let state			= CryptoJS.MD5(mt + rand).toString();
                        
                        sessionStorage.setItem('action_type',"REGIST");

                        tmp_url = `${oauth_naver}authorize?response_type=code&client_id=${client_naver}&redirect_uri=${redirect_naver}&state=${state}`;
                        location.href = tmp_url;
                        
                        break;

                    case "kakao":
                        let oauth_kakao		= "https://kauth.kakao.com/oauth/";
                        let client_kakao	= "fc74e41fba98520112740ae101843b2c";
                        let redirect_kakao	= "https://kr.sidiz.com/pages/kakao-login";
                        
                        sessionStorage.setItem('action_type',"REGIST");

                        tmp_url = `${oauth_kakao}authorize?client_id=${client_kakao}&redirect_uri=${redirect_kakao}&response_type=code`;
                        location.href = tmp_url;
                        
                        break;

                    case "email":
                        if (check_result == "F") {
                            location.href = "/pages/customers-register-sidiz";
                        } else {
                            location.href = "/pages/customers-find-user_email";
                        }
                        
                        break;
                }
            });
        });
    }
}

// 모달 - SNS는 비밀번호 찾기 불가
function modalSnsUnavailable() {
    let mini_contents = `
        <div style="height:256px;">
            <div class="body-1" style="margin-bottom:12px;">
                SNS 계정으로 가입하신 경우,<br>
                해당 플랫폼에서 비밀번호 찾기를 진행해 주세요.
            </div>

            <div class="body-2 text-tertiary">
                카카오/네이버 간편가입의 경우 시디즈에서 해당 SNS 계정의<br>
                비밀번호를 찾거나 변경하실 수 없습니다.
            </div>

            <div style="display:flex;gap:8px;justify-content:center;margin-top:40px;">
                <div class="btn__modal border_basic2" style="color: #434548;">닫기</div>
                <div class="btn__modal btn_find_pw border_basic3">비밀번호 찾기</div>
            </div>
        </div>
    `;

    openMiniModalWithContent(mini_contents, function() {
        let btn_join = document.querySelector('.btn__modal.btn_find_pw');
        if (btn_join) {
            btn_join.addEventListener('click', function() {
                location.href = "/pages/customers-find-user_pw";
            })
        }
    });
}
